// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"7e63d871e474c3ee","2931":"5ad0e383543f516c","4199":"6964c9c07f8ef892","6793":"f57464ca23fa9330"}[chunkId] + ".js";
};